import ErrorBug from 'components/errors/bugs'
import { RouteObject } from 'react-router-dom'
import { PromissoryPublish } from './promissory-publish'
import PromissorySign from './signRegistrarion'
import { SelectSignOrPromissory } from '.'
import SignDetails from './signDetails'
import PromissoryDetails from './promissoryDetails'
import ProtectedRoute from './protectedRoute'
import PromissoryNoteDetails from './promissoryNoteDetails'
import FundLayout from 'layout/fund/FundLayout'

export const promissoryRoutes: RouteObject[] = [
    {
        path: 'promissory',
        element: <ProtectedRoute />,
        errorElement: <ErrorBug />,
        children: [
            {
                path: '/promissory',
                element: <FundLayout helmet="سفته" />,
                errorElement: <ErrorBug />,
                children: [
                    {
                        index: false,
                        path: '',
                        element: <SelectSignOrPromissory />,
                    },
                    {
                        index: false,
                        path: 'promissory-publish/',
                        element: <PromissoryPublish />,
                    },
                    {
                        index: false,
                        path: 'promissory-sign/',
                        element: <PromissorySign />,
                    },
                    {
                        index: false,
                        path: 'sign-details/',
                        element: <SignDetails />,
                    },
                    {
                        index: false,
                        path: 'promissory-details/',
                        element: <PromissoryDetails />,
                    },
                    {
                        index: false,
                        path: 'promissory-note-details/',
                        element: <PromissoryNoteDetails />,
                    },
                ],
            },
        ],
    },
]
